export default __webpack_public_path__ + "static/independenceday2020_2-c4efc1a53d0ff64b4b0268ac960f2ffa.jpg";